import bootstrapper from '../../bootstrapper';
import logger from './logger';
import { emeritusPixelMiddleware, initEmeritusPixel } from './emeritusPixel';

let middlewares;

switch (bootstrapper.appEnv) {
  case 'test': middlewares = [logger, emeritusPixelMiddleware]; break;
  case 'development': middlewares = [logger, emeritusPixelMiddleware]; break;
  case 'review_app': middlewares = [logger, emeritusPixelMiddleware]; break;
  case 'staging': middlewares = [logger, emeritusPixelMiddleware]; break;
  case 'production': middlewares = [emeritusPixelMiddleware]; break;
  default: middlewares = []; break;
}

export default {
  list: middlewares,
  initialize: () => {
    initEmeritusPixel();
  },
};
